import { useEffect } from "react";
import { clearMemoryFields } from "../Components/Agent/MemoryFieldProvider";

const PostLogoutPage = () => {
  useEffect(() => {
    sessionStorage.setItem("loginPopupShown", false);
    sessionStorage.removeItem("userTenant");
    clearMemoryFields();
  }, []);

  return (
    <div
      style={styles.container}
      className="d-flex align-items-center justify-content-center vh-80"
    >
      <div className="text-center">
        <h1 className="mb-4">You have been successfully logged out</h1>
        <button
          className="btn btn-primary"
          onClick={() => {
            sessionStorage.setItem("loginPopupShown", false);
            window.location.href = "/agent";
          }}
          style={{ marginBottom: "10px" }}
        >
          Log In As Agent
        </button>
        <br></br>
        <button
          className="btn btn-primary"
          onClick={() => {
            sessionStorage.setItem("loginPopupShown", false);
            window.location.href = "/";
          }}
        >
          Log In As Admin
        </button>
      </div>
    </div>
  );
};

export default PostLogoutPage;
const styles = {
  container: {
    textAlign: "center",
    margin: "50px auto",
    padding: "20px",
    maxWidth: "600px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
};
